import { Loading } from '@components/loadling';
import { initSdk } from '@proccess/api';
import { notistackRef } from '@proccess/ref/noti';
import { PayloadAction } from '@reduxjs/toolkit';
import { actions } from '@store';
import { AxiosResponse } from 'axios';
import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';

function* requestServicesObject() {
  try {
    Loading.Show();
    const response: AxiosResponse = yield call(() => initSdk.get('/admin/service_patient_objects'));

    if (response.data) {
      yield put(actions.saveServicesObject({ list: response.data }));
    }
  } catch (error) {
    console.error('error', error);
    Loading.Hide();
  } finally {
    Loading.Hide();
  }
}

function* watcherRequestServicesObject() {
  yield takeEvery(actions.requestServicesObject, requestServicesObject);
}

function* requestServiceObject({ payload: { id } }: any) {
  try {
    Loading.Show();
    const response: AxiosResponse = yield call(() =>
      initSdk.get(`/admin/service_patient_objects/${id}`)
    );

    if (response.data) {
      yield put(actions.saveServiceObject({ data: response.data.service_patient_object }));
    }
  } catch (error) {
    console.error('error', error);
    Loading.Hide();
  } finally {
    Loading.Hide();
  }
}

function* watcherRequestServiceObject() {
  yield takeLatest(actions.requestServiceObject, requestServiceObject);
}

function* updateServiceObject({ payload: { data } }: PayloadAction<{ data: any }>) {
  try {
    Loading.Show();
    const response: AxiosResponse = yield call(() =>
      initSdk.patch(`/admin/service_patient_objects/${data.id}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    );
    console.info('🚀 response:', response.data.service);

    if (response.data) {
      yield put(actions.saveServiceObject({ data: response.data }));
      yield call(() =>
        notistackRef.current?.enqueueSnackbar('Cập nhật thành công', { variant: 'success' })
      );
    }
  } catch (error) {
    console.error('error', error);
    yield call(() =>
      notistackRef.current?.enqueueSnackbar('Cập nhật thất bại', { variant: 'error' })
    );
  }
}

function* watcherupdateServiceObject() {
  yield takeLatest(actions.updateServiceObject, updateServiceObject);
}

function* createServiceObject({ payload: { data } }: PayloadAction<{ data: any }>) {
  try {
    Loading.Show();
    const response: AxiosResponse = yield call(() =>
      initSdk.post('/admin/service_patient_objects', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    );
    console.info('🚀 response:', response.data);

    if (response.data) {
      yield put(actions.saveServiceObject({ data: response.data.service_patient_object }));
      yield call(() =>
        notistackRef.current?.enqueueSnackbar('Tạo mới thành công', { variant: 'success' })
      );
    }
  } catch (error) {
    console.error('error', error);
    yield call(() =>
      notistackRef.current?.enqueueSnackbar('Tạo mới thất bại', { variant: 'error' })
    );
  }
}

function* watcherCreateServiceObject() {
  yield takeLatest(actions.createServiceObject, createServiceObject);
}

function* deleteServiceObject({ payload: { id } }: PayloadAction<{ id: any }>) {
  try {
    Loading.Show();
    const response: AxiosResponse = yield call(() =>
      initSdk.delete(`/admin/service_patient_objects/${id}`)
    );
    console.info('🚀 response:', response.data);

    if (response.data) {
      // yield put(actions.({ list: response.data }));
    }
  } catch (error) {
    console.error('error', error);
    Loading.Hide();
  } finally {
    Loading.Hide();
  }
}

function* watcherDeleteServiceObject() {
  yield takeLatest(actions.deleteServiceObject, deleteServiceObject);
}

const serviceObjectSagas = function* root() {
  yield all([
    fork(watcherRequestServicesObject),
    fork(watcherRequestServiceObject),
    fork(watcherupdateServiceObject),
    fork(watcherCreateServiceObject),
    fork(watcherDeleteServiceObject),
  ]);
};
export { serviceObjectSagas };
